import {Call, Pageable, Response} from "@core/model";
import {ApiBuilder} from "..";

export type CallRangeParams = {
  from?: number;
  to?: number;
  outcome?: Call["outcome"];
  page?: number;
  size?: number;
};

// Chiamate per range temporale di inizio, dalla più recente
const fetchCallsByRange = (builder: ApiBuilder) =>
  builder.query<Pageable<Call>, CallRangeParams>({
    query: params => {
      const queryParams = new URLSearchParams();
      if (params.from) {
        queryParams.append("from", params.from.toString());
      }
      if (params.to) {
        queryParams.append("to", params.to.toString());
      }
      if (params.outcome) {
        queryParams.append("outcome", params.outcome);
      }
      if (params.page !== undefined) {
        queryParams.append("page", params.page.toString());
      }
      if (params.size !== undefined) {
        queryParams.append("size", params.size.toString());
      }

      return {
        url: `/api/call/range${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<Pageable<Call>>) => {
      return response.data;
    },
    providesTags: result =>
      result?.content
        ? [
            ...result.content.map((c: Call) => ({
              type: "call" as const,
              id: c.id,
            })),
            {type: "call", id: "LIST"},
          ]
        : [{type: "call", id: "LIST"}],
  });

export {fetchCallsByRange};
